import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { saveAs } from "file-saver";
import styles from "../commanstyles.module.css";
import { IoMdLock } from "react-icons/io";
import {
  downloadrequestdocuments,
  getdownloadrequestdocuments,
} from "../../../Services/APIrequests";
import { SuccessSwal, warningSwal } from "../../../Util/Toast";

function FinancialDocuments({ documents, isSubScribe, activeTab }) {
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedDocs, setSelectedDocs] = useState([]);
  const [availableArchives, setAvailableArchives] = useState([]);
  const [showMessage, setShowMessage] = useState(false);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const { cin } = useParams();

  const itemsPerPage = 5;
  const totalPages = Math.ceil(documents.length / itemsPerPage);
  const paginatedDocuments = documents.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  useEffect(() => {
    if (cin) {
      getAvailableArchives(cin);
    }
  }, [cin]);

  const getAvailableArchives = async (cin) => {
    try {
      const response = await getdownloadrequestdocuments(cin);
      if (response.status === 200) {
        const archives = response.data.docs;
        const sortedArchives = archives.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setAvailableArchives(sortedArchives);
      } else {
        console.error("Failed to fetch available archives: ", response);
      }
    } catch (error) {
      console.error("Error fetching available archives:", error);
    }
  };

  const formatDate = (dateString) => {
    const options = {
      weekday: "short",
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true, // 12-hour format
    };
    const date = new Date(dateString);
    return date.toLocaleString("en-US", options);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  const handleSelectDoc = (docId) => {
    setSelectedDocs((prev) =>
      prev.includes(docId)
        ? prev.filter((id) => id !== docId)
        : [...prev, docId]
    );
  };

  const handleArchiveClick = (documentURL) => {
    saveAs(documentURL, "document.zip");
  };

  const handleSelectAll = () => {
    if (isAllSelected) {
      setSelectedDocs([]);
    } else {
      setSelectedDocs(documents.map((doc) => doc.reference_document_id));
    }
    setIsAllSelected(!isAllSelected);
  };

  const handleDownloadSelected = async () => {
    if (selectedDocs.length === 0) {
      alert("Please select some documents to download.");
      return;
    }

    const body = {
      ids: selectedDocs,
      document_type: activeTab,
    };

    try {
      const response = await downloadrequestdocuments(body);
      if (response.status === 200) {
        const archive = response.data;
        SuccessSwal(
          response.data.message,
          "Your request to archive documents has been submitted. Please check back later."
        );
      } else {
        warningSwal(
          "Failed to download selected documents. Please try again.",
          "warning"
        );
      }
    } catch (error) {
      warningSwal(
        error?.response?.data?.message ||
          "Something went wrong, please try again later.",
        "warning"
      );
    }
  };

  const handleDocumentNameClick = (documentURL) => {
    saveAs(documentURL, "document.zip");
  };

  const handleCloseMessage = () => {
    setShowMessage(false); // Close the tooltip when the "OK" button is clicked
  };

  return (
    <div>
      {selectedDocs.length > 0 && (
        <div className={styles.downloadContainer}>
          <div>{selectedDocs.length} documents selected for download</div>
          <button
            className={styles.downloadButton}
            onClick={handleDownloadSelected}
          >
            Download Selected as ZIP
          </button>
        </div>
      )}

      {showMessage && (
        <div className={styles.archiveMessage}>
          <p>
            Your request to archive documents has been submitted. Please check
            back later.
          </p>
          <button onClick={handleCloseMessage} className={styles.okButton}>
            OK
          </button>
        </div>
      )}

      {!isSubScribe && (
        <button className={styles.Subscription_msg}>
          <IoMdLock /> Subscription required to view data
        </button>
      )}

      {isSubScribe && (
        <div className={styles.table_subcontainer}>
          <table className={styles.commantable}>
            <thead>
              <tr className={styles.tableHeaderRow}>
                <th className={styles.tableHeader}>Document Name</th>
                <th className={styles.tableHeader}>Attachments</th>
                <th className={styles.tableHeader}>Filing Date</th>
                <th className={styles.tableHeader}>Type</th>
                <th className={styles.tableHeader}>
                  Size (KB)
                  <input
                    type="checkbox"
                    checked={isAllSelected}
                    onChange={handleSelectAll}
                  />
                </th>
              </tr>
            </thead>
            <tbody>
              {paginatedDocuments.length === 0 ? (
                <tr>
                  <td
                    colSpan="5"
                    style={{ textAlign: "center", color: "#808080" }}
                  >
                    No Data Available
                  </td>
                </tr>
              ) : (
                paginatedDocuments.map((doc) => (
                  <tr
                    key={doc.reference_document_id}
                    className={styles.tableRow}
                  >
                    <td className={styles.tableCell}>
                      <a
                        href="#"
                        onClick={() =>
                          handleDocumentNameClick(doc.document_url)
                        }
                        className={styles.documentLink}
                      >
                        {doc.document_name}
                      </a>
                    </td>
                    <td className={styles.tableCell}>
                      {doc.attachments && doc.attachments.length > 0 ? (
                        <ul className={styles.attachmentList}>
                          {doc.attachments.map((file, index) => (
                            <li
                              key={index}
                              className={styles.attachmentListItem}
                            >
                              <a
                                href={file.fileurl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={styles.attachmentLink}
                              >
                                {file.Name}
                              </a>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <span>No attachments available</span>
                      )}
                    </td>
                    <td className={styles.tableCell}>
                      {doc.filing_date
                        ? new Date(doc.filing_date).toLocaleDateString(
                            "en-GB",
                            {
                              day: "numeric",
                              month: "short",
                              year: "numeric",
                            }
                          )
                        : "NA"}
                    </td>
                    <td className={styles.tableCell}>{doc.form_type}</td>
                    <td className={styles.tableCell}>
                      {doc.size_in_kb}
                      <input
                        type="checkbox"
                        checked={selectedDocs.includes(
                          doc.reference_document_id
                        )}
                        onChange={() =>
                          handleSelectDoc(doc.reference_document_id)
                        }
                      />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>

          {documents.length > 0 && (
            <div className={styles.paginationControls}>
              <button onClick={handlePrevPage} disabled={currentPage === 1}>
                Previous
              </button>
              <span>
                Page {currentPage} of {totalPages}
              </span>
              <button
                onClick={handleNextPage}
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          )}

          {documents.length > 0 && (
            <>
              <h3>Available Archives</h3>
              {Array.isArray(availableArchives) &&
              availableArchives.length === 0 ? (
                <p>No available archives found.</p> // Show this message when there are no archives
              ) : (
                <table className={styles.commantable}>
                  <thead>
                    <tr className={styles.tableHeaderRow}>
                      <th className={styles.tableHeader}></th>
                      <th className={styles.tableHeader}>Name</th>
                      <th className={styles.tableHeader}>Size(KB)</th>
                      <th className={styles.tableHeader}>Expire Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {availableArchives.length === 0 ? ( // If no archives, show placeholder
                      <tr>
                        <td
                          colSpan="4"
                          className={styles.tableCell}
                          style={{ textAlign: "center" }}
                        >
                          No available archives found.
                        </td>
                      </tr>
                    ) : (
                      availableArchives.map((archive, index) => (
                        <tr key={index}>
                          <td className={styles.tableCell}>{index + 1}</td>
                          <td
                            className={styles.tableCell}
                            onClick={() =>
                              handleArchiveClick(archive.documentURL)
                            }
                            style={{ cursor: "pointer" }}
                          >
                            {archive.documentName}
                          </td>
                          <td className={styles.tableCell}>
                            {(archive.size / 1024).toFixed(2)}
                          </td>
                          <td>{formatDate(archive.expiryDateTime)}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default FinancialDocuments;
